import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=4a0890cf&scoped=true&"
import script from "./Skills.vue?vue&type=script&lang=js&"
export * from "./Skills.vue?vue&type=script&lang=js&"
import style0 from "./Skills.vue?vue&type=style&index=0&id=4a0890cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0890cf",
  null
  
)

export default component.exports